import { useRoleDetection } from "../../../context/AuthContext";
import { EnhancedAdminDashboard } from "../admin/enhanced-admin-dashboard";
import { MerchantDashboard } from "../../merchant/merchant-dashboard";

export function DashboardPage() {
  try {
    const { isAdmin, isMerchant } = useRoleDetection();

    return (
      <>
        {/* Main Content */}
        {isAdmin ? (
          <EnhancedAdminDashboard />
        ) : isMerchant ? (
          <MerchantDashboard />
        ) : (
          // Fallback for other roles or when role detection fails
          <div className="flex items-center justify-center min-h-screen">
            <div className="text-center">
              <h2 className="text-xl font-semibold">Access Restricted</h2>
              <p className="text-muted-foreground mt-2">
                You don't have permission to view the dashboard
              </p>
            </div>
          </div>
        )}
      </>
    );
  } catch (error) {
    console.error('Dashboard error:', error);
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <h2 className="text-xl font-semibold text-destructive">Error</h2>
          <p className="text-muted-foreground mt-2">Unable to load dashboard</p>
          <p className="text-sm text-muted-foreground mt-1">Please try refreshing the page</p>
        </div>
      </div>
    );
  }
}